import { useMediaQuery } from "@mui/material";
import {
  SimpleShowLayout,
  ArrayField,
  Datagrid,
  TextField,
  ReferenceField,
  BooleanField,
  useRecordContext,
  Labeled,
} from "react-admin";
import { Grid, Box } from "@mui/material";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";
import { specialistRequests } from "api/specialistApi";
import { administrationRequests } from "api/administrationApi";

const MobileSpecializationsList = () => {
  const record = useRecordContext();

  if (!record?.specializationOptions?.length) return null;

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
    >
      {record.specializationOptions.map((item, index) => (
        <Box
          key={index}
          display="flex"
          flexDirection="column"
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: 2,
            p: 2,
            boxShadow: 1,
            backgroundColor: "#fff",
          }}
        >
          <Labeled label="Специалност">
            <ReferenceField
              record={item}
              source="specializationId"
              reference={specialistRequests.getSpecializationsSelect()}
              link={false}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          </Labeled>

          <Labeled label="Тип прием">
            <ReferenceField
              record={item}
              source="receptionTypeId"
              reference={administrationRequests.getReceptionTypesSelect()}
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>

          <Labeled label="Сграда">
            <ReferenceField
              record={item}
              source="trainingBuildingId"
              reference={specialistRequests.getTrainingBuildingsSelect()}
              link={false}
            >
              <TextField source="buildingNameBg" />
            </ReferenceField>
          </Labeled>

          <Labeled label="Само за служители">
            <BooleanField
              record={item}
              source="isEmployeesOnly"
            />
          </Labeled>
          <Labeled label="Практическо обучение от университета">
            <BooleanField
              record={item}
              source="isPracticeTrainingProvidedByUniversity"
            />
          </Labeled>
        </Box>
      ))}
    </Box>
  );
};

const SpecializationsSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <SimpleShowLayout>
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <SectionTitle
            title="Специализации"
            paddingY={0}
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <ArrayField source="specializationOptions">
            {isMobile ? (
              <MobileSpecializationsList />
            ) : (
              <Datagrid
                bulkActionButtons={false}
                rowClick={false}
                sx={[settings.style.detailsDatagrid, { "& .RaDatagrid-headerCell": { textAlign: "left" } }]}
              >
                <ReferenceField
                  source="specializationId"
                  reference={specialistRequests.getSpecializationsSelect()}
                  label="Специалност"
                  sortable={false}
                >
                  <TextField source="nameBg" />
                </ReferenceField>
                <ReferenceField
                  source="receptionTypeId"
                  reference={administrationRequests.getReceptionTypesSelect()}
                  label="Тип прием"
                  sortable={false}
                >
                  <TextField source="name" />
                </ReferenceField>

                <ReferenceField
                  source="trainingBuildingId"
                  reference={specialistRequests.getTrainingBuildingsSelect()}
                  label="Сграда"
                  sortable={false}
                  emptyText="x"
                  link={false}
                >
                  <TextField source="buildingNameBg" />
                </ReferenceField>
                <BooleanField
                  source="isEmployeesOnly"
                  label="Само за служители"
                  emptyText="x"
                  sortable={false}
                />
                <BooleanField
                  source="isPracticeTrainingProvidedByUniversity"
                  label="Практическо обучение от университета"
                  sortable={false}
                  emptyText="x"
                />
              </Datagrid>
            )}
          </ArrayField>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default SpecializationsSection;
